import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "info-panel-container" }
const _hoisted_2 = { style: {"cursor":"help","border-bottom":"1px dotted var(--text-color-secondary)"} }

import { ref, onBeforeMount, computed, inject } from "vue";
import Tree from 'primevue/tree';
import { TreeNode } from 'primevue/treenode';
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import DataView from "primevue/dataview";
import { emitError } from "vue-json-pretty/types/utils";
import { BeakerSessionComponentType } from '../session/BeakerSession.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoPanel',
  setup(__props) {

const contextPanelOpen = ref(true);
const toggleContextPanel = () => {
    contextPanelOpen.value = !contextPanelOpen.value;
};

// This should mostly be uncontrolled, but it was
// "hard" to open by default without controlling
// TODO easier way for tree to auto-open by default
const contextExpandedKeys = ref({0: true, 1: true, 2: true, 3: true});

const beakerSession = inject<BeakerSessionComponentType>("beakerSession");
const activeContext = computed(() => {
    const contextInfo = beakerSession?.activeContext;
    const kernelInfo = beakerSession?.session.kernelInfo;
    return {
        ...contextInfo,
        kernelInfo,
    };
});

const contextNodes = computed<TreeNode[]>(() => {

    const context = activeContext.value;

    if (!context) {
        return [];
    }

    const displayableNodes: TreeNode[] = [{
        key: "0",
        label: 'Kernel',
        icon: 'pi pi-fw pi-cog',
        expanded: true,
        children: [
            {
                key: '0-1',
                label: `${context?.info?.subkernel} (${context?.info?.language})`,
            },
            // ...Object.entries(context?.kernelInfo || {}).map(
            //     ([key, value]) => {
            //         return {
            //             key: `0-${key}`,
            //             label: `${key}: ${value}`,
            //         }
            //     }
            // ),
    ]
    }];

    displayableNodes.push({
        key: "3",
        label: 'Tools',
        icon: 'pi pi-fw pi-wrench',
        expanded: true,
        children: Object.keys(context?.info?.agent?.tools || {})
            .map((toolname, idx) => ({
                key: `3-${idx}`,
                label: toolname.replace('PyPackageAgent.', ''),
                data: context.info.agent.tools[toolname],
                type: 'tool'
            }))
    });

    return displayableNodes;

});


return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Tree), {
      value: contextNodes.value,
      loading: !contextNodes.value,
      expandedKeys: contextExpandedKeys.value,
      "onUpdate:expandedKeys": _cache[1] || (_cache[1] = ($event: any) => ((contextExpandedKeys).value = $event))
    }, {
      loadingicon: _withCtx(() => _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "loading-area" }, " No Context Loaded. ", -1)
      ])),
      action: _withCtx((slotProps) => [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          onMousedown: _cache[0] || (_cache[0] = ($event: any) => {($event.detail > 1) && $event.preventDefault();}),
          style: {"cursor":"pointer","border-bottom":"1px dotted var(--text-color-secondary)"}
        }, [
          _createTextVNode(_toDisplayString(slotProps.node.label), 1)
        ], 32)), [
          [_directive_tooltip, {
                    value: `${slotProps.node.data}`,
                    pt: {
                        text: {
                            style: {
                                width: '20rem'
                            }
                        },
                        root: {
                            style: {
                                marginLeft: '1rem'
                            }
                        }
                    }
                    }]
        ])
      ]),
      tool: _withCtx((slotProps) => [
        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(slotProps.node.label), 1)
        ])), [
          [_directive_tooltip, {
                    value: `${slotProps.node.data}`,
                    pt: {
                        text: {
                            style: {
                                width: '20rem'
                            }
                        },
                        root: {
                            style: {
                                marginLeft: '1rem'
                            }
                        }
                    }
                    }]
        ])
      ]),
      _: 1
    }, 8, ["value", "loading", "expandedKeys"])
  ]))
}
}

})